import React from 'react';
import styled from 'styled-components';
import cn from 'classnames';

const FlexColumn = ({ className, children, style, innerRef }) => {
  return (
    <div className={cn('FlexColumn', className)} style={style} ref={innerRef}>
      {children}
    </div>
  );
};

export default styled(FlexColumn)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
`;
